import React, { Fragment } from 'react'
import AwardTop3 from './AwardTop3'
import AwardTop7 from './AwardTop7'

const AwardTop = ({
  entries = [],
  omitTop7 = false,
  className = "",
  previewLink = null,
}) => {

  return (
    <div className={`awards-top-hight ${className}`}>
      <AwardTop3 entries={entries.slice(0, 3)} previewLink={previewLink} />
      {!omitTop7 && <AwardTop7 entries={entries.slice(3)} previewLink={previewLink} />}
    </div>
  )
}

export default AwardTop;
